import { createContext, useContext } from 'react';
import { type QuizAnswers, ProfileFields } from './types';
import { ProfileStepIds } from '@/models/recommendation';

export const initialQuizAnswers: QuizAnswers = {
  [ProfileFields.AgreedToReceiveEmails]: false,
  [ProfileFields.Email]: null,
  [ProfileFields.Phone]: null,
  [ProfileFields.NonResident]: null,
  [ProfileFields.CurrentJob]: null,
  [ProfileFields.DesiredJob]: null,
  [ProfileFields.AddressCity]: null,
  [ProfileFields.AddressState]: null,
  [ProfileFields.Scholarity]: null,
  [ProfileFields.Goal]: null,
  [ProfileFields.CourseTypes]: null,
  [ProfileFields.Languages]: null,
};

interface ProfileQuizContextType {
  answers: QuizAnswers;
  setQuizAnswer: (
    field: ProfileFields,
    value: QuizAnswers[ProfileFields]
  ) => void;
  currentQuestionId: ProfileStepIds;
  visibleQuestionIds: ProfileStepIds[];
  submittedQuestionId: ProfileStepIds | null;
  submit: () => void;
  goNext: () => void;
  goBack: () => void;
  canGoBack: boolean;
  canGoNext: boolean;
  isLastQuestion: boolean;
  isQuizComplete: boolean;
  setCurrentStepValid: (isValid: boolean) => void;
}

export const ProfileQuizContext = createContext<ProfileQuizContextType>({
  answers: initialQuizAnswers,
  setQuizAnswer: () => {},
  currentQuestionId: ProfileStepIds.PresentationWelcome,
  visibleQuestionIds: [],
  submittedQuestionId: null,
  submit: () => {},
  goNext: () => {},
  goBack: () => {},
  canGoBack: false,
  canGoNext: true,
  isLastQuestion: false,
  isQuizComplete: false,
  setCurrentStepValid: () => {},
});

export const useProfileQuiz = () => {
  return useContext(ProfileQuizContext);
};
